// groups/my-model
import { getData, postData } from 'src/services/RestApi';

/**
 * VIEW
 */
export const getTree = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/group/tree';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);
  
  return onSuccess(result);
};

export const getList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/group/list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  return onSuccess(result);
};

export const getItemById = async (payload) => {
  const groupId = Number(payload?.id) || 0;
  if (groupId === 0) return {};

  const { result, error } = await getData('api/group/detail', { groupId });
  if(error) return {};

  return result;
};

/**
 * FORM
 */
export const apiCreate = async (values) => {
  const queryData = requestParams(values);
  return await postData('api/group/create', queryData);
};

export const apiUpdate = async (values) => {
  const queryData = requestParams(values);
  // Remove group
  const { parent, ...queryFilter } = queryData;
  queryFilter.groupId = values.id;

  return await postData('api/group/update', queryFilter);
};

export const apiDelete = async (payload) => {
  return await postData('api/group/delete', {groupId: payload.id});
};

function requestParams(values) {
  const queryData = {};
  if (values.name) {
    queryData.name = values.name;
  }
  if (values.group) {
    queryData.parent = values.group.value;
  }
  if (values.locationField) {
    queryData.location = values.locationField.value;
  }
  
  return queryData;
}
